import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { takeWhile } from 'rxjs';

import { WelcomeContinueService } from './welcome-continue.service';

@Component({
  selector: 'app-welcome-continue',
  templateUrl: './welcome-continue.component.html',
  standalone: true,
  imports: [RouterLink, RouterOutlet]
})
export class WelcomeContinueComponent implements OnInit, OnDestroy {
  private alive: boolean;
  titleText: string;

  constructor(private stateService: WelcomeContinueService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.alive = true;
    this.stateService.titleText.pipe(takeWhile(() => this.alive)).subscribe((v) => (this.titleText = v));

    this.route.queryParams.pipe(takeWhile(() => this.alive)).subscribe(({ next: nextPath }) => {
      if (nextPath) {
        const urlTree = this.router.parseUrl(nextPath);
        this.stateService.nextPath = `/${urlTree.root.children['primary']?.segments.map((it) => it.path).join('/')}`;
      }
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
